export default {
    singleDirectoryItemUpdate: function (eventId, item) {
        return { type: 'UPDATE_EVENT_SINGLE_DIRECTORY_ITEM', eventId, item };
    },
    updateDirectoryData: function (eventId, directoryId, items, fetchTime) {
        return { type: 'UPDATE_EVENT_DIRECTORY_DATA', eventId, directoryId, items, fetchTime };
    },
};
